import {
    ValueComponent,
    ValueComponentDefinition,
} from "components/components/Component";

export class NumbersId  implements ValueComponent {
    public id: string;
    public readonly componentType = "numbersId";
    private val: number[];
    public definition: ValueComponentDefinition;

    constructor(schema: ValueComponentDefinition) {
        this.definition = schema;
    }
    public render(): Element {
        return null;
    }

    public getValue(): number[] {
        return this.val;
    }
    public value(v: number[]) {
        this.val = v;
    }
}
